import React, { useEffect, useState } from 'react';
import { getLoginUrl } from '../services/api';
import { saveToken } from '../utils/tokenStorage';
import './LoginPage.css';

function LoginPage({ onLoginSuccess }) {
  const [loginUrl, setLoginUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleTokenExchange = async (requestToken) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/callback`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ requestToken })
        });

        const data = await response.json();
        if (data.jwtToken) {
          saveToken(data.jwtToken);
          onLoginSuccess();
        } else {
          setError('Failed to authenticate');
        }
      } catch (err) {
        setError('Error during authentication: ' + err.message);
      }
    };

    const fetchLoginUrl = async () => {
      try {
        const url = await getLoginUrl();
        setLoginUrl(url);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch login URL. Make sure backend is running.');
        setLoading(false);
      }
    };

    fetchLoginUrl();

    // Check for request token in URL (after redirect from Kite login)
    const params = new URLSearchParams(window.location.search);
    const requestToken = params.get('request_token');
    if (requestToken) {
      handleTokenExchange(requestToken);
    }
  }, [onLoginSuccess]);

  if (loading) {
    return <div className="login-container"><p>Loading...</p></div>;
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>NSE Trading App</h1>
        <p className="subtitle">Powered by Kite API</p>

        {error && <div className="error-message">{error}</div>}

        {loginUrl ? (
          <a href={loginUrl} className="login-button">
            Login with Kite
          </a>
        ) : (
          <p className="error-message">Unable to get login URL. Please refresh the page.</p>
        )}

        <p className="info-text">
          You will be redirected to Kite login page to authenticate securely.
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
